export default function setupAxios(axios, store) {
  axios.interceptors.request.use((config) => {
    config.params = { ...config.params, login: "email" };
    return config;
  });
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );
}
const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  let [resource, config] = args;
  const url =
    typeof resource === "string"
      ? resource
      : resource instanceof URL
        ? resource.href
        : resource.url;

  const loginMethod = window.localStorage.getItem("loginMethod") || "email";
  if (
    !url.includes("itsthezonezone-uploads") &&
    !url.includes("googleapis.com") &&
    (url.includes("the-zone") ||
      url.includes("localhost") ||
      url.includes("itsthezone"))
  ) {
    const safeLogin = encodeURIComponent(loginMethod);
    const updatedUrl = url.includes("?")
      ? url + `&login=${safeLogin}`
      : url + `?login=${safeLogin}`;
    resource =
      typeof resource === "string" || resource instanceof URL
        ? updatedUrl
        : new Request(updatedUrl, resource);
  }

  const response = await originalFetch(resource, config);

  return response;
};
